module.exports = __webpack_public_path__ + "img/11_9.e6a04d8b.png";